import React from 'react';
import {SvgProps} from '../../helpers/type';

const ExpandArrow = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M7.07108 16.0706L13.1422 8.99951L7.07108 1.92844"
                stroke="#174943"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ExpandArrow;
